import { render, staticRenderFns } from "./CopyrightAmendmentEscalationFile.vue?vue&type=template&id=ca4f8be0&scoped=true&"
import script from "./CopyrightAmendmentEscalationFile.vue?vue&type=script&lang=js&"
export * from "./CopyrightAmendmentEscalationFile.vue?vue&type=script&lang=js&"
import style0 from "./CopyrightAmendmentEscalationFile.vue?vue&type=style&index=0&id=ca4f8be0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca4f8be0",
  null
  
)

export default component.exports